'use client';

import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft } from '@phosphor-icons/react';
import { InfoIcon } from '@/components/icons';
import { cn } from '@/lib/utils';

interface PaidExtrasModalProps {
  isOpen: boolean;
  onGoBack: () => void;
  onContinue: () => void;
}

export function PaidExtrasModal({ isOpen, onGoBack, onContinue }: PaidExtrasModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[9999]">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
            onClick={onContinue}
          />

          {/* Mobile: bottom sheet */}
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 28, stiffness: 300 }}
            className={cn(
              'fixed bottom-0 left-0 right-0 md:hidden',
              'rounded-t-screen bg-[var(--surface-primary)] p-6 pb-8',
              // Модалка — исключение из уплощения (ответ 35, второй вопрос = 2),
              // объём остаётся. Токена для тени ВВЕРХ нет: shadow-deep светит
              // вниз, за край экрана, и шторка потеряла бы отрыв от контента.
              'shadow-[0_-8px_30px_rgba(0,0,0,0.12)]'
            )}
          >
            <div className="mb-3 flex justify-center">
              <div className="h-1 w-10 rounded-hairline bg-[var(--border-default)]" />
            </div>
            <ModalBody onGoBack={onGoBack} onContinue={onContinue} />
          </motion.div>

          {/* Desktop: centered modal */}
          <div className="hidden md:flex fixed inset-0 items-center justify-center p-4">
            <motion.div
              initial={{ scale: 0.92, opacity: 0, y: 16 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.92, opacity: 0, y: 16 }}
              transition={{ type: 'spring', damping: 28, stiffness: 300 }}
              className={cn(
                'relative w-full max-w-sm rounded-screen',
                'bg-[var(--surface-primary)] p-8',
                // Модалка сохраняет глубину (ответ 35 = 2): shadow-deep вдвое
                // слабее и оторвал бы окно от затемнённого фона хуже, чем сейчас.
                'shadow-[0_16px_48px_rgba(0,0,0,0.15)]'
              )}
            >
              <ModalBody onGoBack={onGoBack} onContinue={onContinue} />
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
}

function ModalBody({ onGoBack, onContinue }: { onGoBack: () => void; onContinue: () => void }) {
  return (
    <div className="text-center">
      <div className="mx-auto mb-4 w-16 h-16 rounded-card bg-[var(--primary-subtle)] flex items-center justify-center">
        <InfoIcon size={32} weight="duotone" className="text-[var(--primary)]" />
      </div>
      <h3 className="text-lg font-bold text-[var(--text-primary)]">
        Соусы — отдельно
      </h3>
      <p className="mt-2 text-sm text-[var(--text-secondary)] leading-relaxed">
        Соевый соус, васаби и имбирь не включены в стоимость блюд. Не забудьте добавить.
      </p>

      <div className="mt-6 flex flex-col gap-2.5">
        <button
          onClick={onGoBack}
          className={cn(
            'w-full py-3.5 rounded-card font-semibold text-sm flex items-center justify-center gap-2',
            'bg-[var(--primary)] text-white',
            'hover:bg-[var(--primary-hover)] transition-colors',
            'active:scale-[0.98] transition-transform'
          )}
        >
          <ArrowLeft size={16} weight="bold" />
          Вернуться и добавить
        </button>
        <button
          onClick={onContinue}
          className={cn(
            'w-full py-3.5 rounded-card font-semibold text-sm',
            'border border-[var(--border-default)] text-[var(--text-secondary)]',
            'hover:bg-[var(--surface-hover)] transition-colors',
            'active:scale-[0.98] transition-transform'
          )}
        >
          Понял(а), продолжить
        </button>
      </div>
    </div>
  );
}
